<template>
    <div class="statistics">
        <el-row>
            <el-col v-for="(statistic, index) in patientStatistics" :span="6" :xl="3" 
                class="statistic"
                :key="index">

                <el-row style="padding: 5px 25px 5px 10px;"  >
                    <el-col :span="18">
                        <p class="statCount" @click="patientList(statistic.patient)">{{ statistic.patient.length }}</p>
                        <span class="stat-text">{{ statistic.label }} </span>
                    </el-col>
                    <el-col :span="6" type="flex" align="end" >
                        <div class="flex-wrapper">
                            <div class="single-chart">
                                <svg viewBox="0 0 36 36" class="circular-chart orange">
                                    <path class="circle-bg"
                                          d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <path class="circle"
                                          :stroke-dasharray="statistic.percent + ', 100'"
                                          d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                                    />
                                    <text v-if="statistic.percent > 0" x="18" y="20.35" class="percentage">
                                        {{ Math.round(statistic.percent) }}%
                                    </text>
                                </svg>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import OutcomeMixin from './mixin'

const STATISTICS = [
    {
        label: 'total patients',
        compute: (records, patientRecordMap) => Object.keys(patientRecordMap)
    },
    {
        label: 'responded',
        compute: (records, patientRecordMap) => Object.keys(patientRecordMap).filter((id) => patientRecordMap[id].some((record) => record.completed))
    },
    {
        label: 'opened, but didn\'t complete',
        compute: (records, patientRecordMap) => Object.keys(patientRecordMap).filter((id) =>
            (patientRecordMap[id].every((record) => !record.completed) &&
             patientRecordMap[id].some((record) => record.question != null))
        )
    },
    {
        label: 'did not open',
        compute: (records, patientRecordMap) => Object.keys(patientRecordMap).filter((id) =>
            (patientRecordMap[id].every((record) => !record.completed && record.question == null))
        )
    }
]

export default {
    name: 'outcome-questionnaire-statistics',
    mixins: [ OutcomeMixin ],

    data() {
        return {
            statistics: STATISTICS
        }
    },

    computed: {
        patientRecordMap() {
            var patient = {}
            if(this.filteredRecords)
                this.filteredRecords.forEach((record) => {
                    if (! patient[record.auth])
                        patient[record.auth] = []
                    patient[record.auth].push(record)
                })
            return patient
        },
        patientCount() {
            return Object.keys(this.patientRecordMap).length
        },
        patientStatistics() {
            return this.statistics.map((statistic) => ({
                label: statistic.label,
                patient: statistic.compute(this.records, this.patientRecordMap)
            }))
            .map((statistic) => {
                if (this.patientCount > 0)
                    statistic.percent = 100.0 * statistic.patient.length / this.patientCount
                return statistic
            })
        }
    },
    methods: {
        /**
         * Emits patient list to QuestionnaireCard to show patient list
         */
        patientList(patientList) {
            this.$emit('patient-list', patientList.map(patient => ({user: patient})))
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/module/app/theme/color.scss";

    .statistics {
        background: #f2e2f4;
        padding: 10px 5px 0px 15px;
    }
    .statistic {
        background: white;
        padding: 15px;
        height: 130px;
        border-right: solid 10px #f2e2f4;
    }

    .statCount {
        font-size: 70px;
        font-weight: 300;
        color: $questionnaire-color;
        cursor: pointer;
    }
    .statCircle {
        position: relative;
        height: 60px;
        width: 60px;
        border-radius: 100px;
        border: 4px solid $questionnaire-color;
    }
    .percentage {
        position: absolute;
        top: 18px;
        left: 12px;
        color: #7f7f7f;
    }
    .stat-text{
        font-size: 16px;
        color: #333;
    }


    .flex-wrapper {
        display: flex;
        flex-flow: row nowrap;
    }

    .single-chart {
        height: 120px;
        width: 100%;
        justify-content: space-around ;
    }

    .circular-chart {
        display: block;
        margin: 0px auto;
        height: 60%;
    }

    .circle-bg {
        fill: none;
        stroke: #eee;
        stroke-width: 3.8;
    }

    .circle {
        fill: none;
        stroke-width: 2.8;
        stroke-linecap: round;
        animation: progress 1s ease-out forwards;
    }

    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }

    .circular-chart.orange .circle {
        stroke: $questionnaire-color;
    }
    .percentage {
        fill: #333;
        font-size: 0.5em;
        text-anchor: middle;
    }
</style>
